<template>
  <div class="title">
    <h1>Projects</h1>
    <div class="pure-g">
      <div class="pure-u-1 pure-u-sm-1-2">
        <div class="project">
          <h3><a href="https://4cast.app">4CAST</a></h3>
          <p><a href="https://4cast.app">4cast</a> is a web application for manually logging the surf forecast.</p>

          <p><strong>Stack:</strong></p>
          <ul>
            <li>Vue</li>
            <li>node.js</li>
            <li>express</li>
            <li>mongoDB</li>
          </ul>
        </div>
      </div>

      <div class="pure-u-1 pure-u-sm-1-2">
        <div class="project">
          <a href="https://www.dolefund.com">
              <img src="../assets/df-logo.png" class="logo">
            </a>
          <p><a href="http://dolefund.com">DoleFund</a> is an online registry for non-profits and charities that creates transparency for donors, allowing them to know exactly how their dollar is spent.</p>

          <p><strong>Stack:</strong></p>
          <ul>
            <li>Django REST Framework</li>
            <li>PostgreSQL</li>
            <li>Heroku</li>
            <li>Vue.js</li>
          </ul>
        </div>
      </div>

      <div class="pure-u-1 pure-u-sm-1-2">
        <div class="project">
          <h3><a href="http://forms.astopo.com">Simple Form Backend</a></h3>
          <p>A bare-bones node.js app that accepts form data, and emails it to you. Integrated with SendGrid.</p>

          <p><strong>Stack:</strong></p>
          <ul>
            <li>Node.js</li>
            <li>Express</li>
            <li>SendGrid</li>
          </ul>
        </div>
      </div>

      <div class="pure-u-1 pure-u-sm-1-2">
        <div class="project">
          <h3><a href="http://www.ultimatebreakout.com/">Ultimate Breakout</a></h3>
          <p>A remake of the popular breakout game. Real-time, with a leaderboard, built with Phaser game engine.</p>

          <p><strong>Stack:</strong></p>
          <ul>
            <li>Phaser</li>
            <li>Node.js</li>
          </ul>
        </div>
      </div>

      <div class="pure-u-1 pure-u-sm-1-2">
        <div class="project">
          <h3><a href="http://bookorbit.astopo.com/"><img src="../assets/book-orbit.png" class="logo-sq">Book Orbit</a></h3>
          <p>A resource library. Save and tag links. Scrapes the webpage when the bookmark is created to display a preview of the content in the app.</p>
          <p><strong>Stack:</strong></p>
          <ul>
            <li>Ruby on Rails</li>
            <li>PostgreSQL</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Projects',
  props: {}
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  padding: 0;
}

.project {
  padding: 2rem;
  text-align: left;
}

.logo {
  max-width: 200px;
}

.logo-sq {
  max-width: 30px;
  margin-right: 0.5rem;
  margin-bottom: -10px;
}
</style>
